var React = require('react');

function LetsTalk (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_2212","data-name":"Group 2212","transform":"translate(-1135.411 -572.36)"},[React.createElement("path",{"id":"Path_3442","data-name":"Path 3442","d":"M5719.411,10947.36v23.08h27.2","transform":"translate(-4583 -10375)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_3443","data-name":"Path 3443","d":"M5733.009,10945.249l13.925,7.732-13.925,7.775","transform":"translate(-4583 -10357.563)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

LetsTalk.defaultProps = {"width":"30.579","height":"31.707","viewBox":"0 0 30.579 31.707"};

module.exports = LetsTalk;

LetsTalk.default = LetsTalk;
